import {Divider, Button, MantineTheme} from '@mantine/core';
import React, {useState} from 'react';
import "../../../../../css/step2.css";
import CronUIModal from '../../../../../tsx/cronUiModal';
import {KpiProps} from "../../../../../types/types";
import "./SchedulerConfigurationStep.css"
import {AggregationModal} from "./modal/AggregationModal";
import { ArrayUtils } from '../../../../../utils/arrayUtils';
import {Text} from "@mantine/core";
import { ConfirmationPopUp } from '../../../../popup/confirmationPopUp';
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function SchedulerConfigurationStep(props: KpiProps) {
    const [opened, setOpened] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openAggrConfirmModal, setOpenAggrConfirmModal] = useState(false);
    const [openedCronUi, setOpenedCronUi] = useState(false);
    const schedulerError = ArrayUtils.isNotEmpty(props.validationErrors) && props.validationErrors.filter(error => error.property === 'scheduler').map(error => error.message)[0]

    const isAggregation = () => {
        if(props.kpiInfo.cron){
            setOpenConfirmModal(true);
        }
        else{
            setOpened(true);
        }
    }

    const isScheduler = () => {
        if(props.kpiInfo.aggregationNames && props.kpiInfo.aggregationNames.length){
            setOpenAggrConfirmModal(true);
        }
        else{
            setOpenedCronUi(true);
        }

    }

    const themeProvider = (theme: MantineTheme) => ({
        color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[9],
        '&:hover': {
            backgroundColor: theme.colors.teal[9],
            color: theme.colors.gray[0]
        },
    })

    const clearCronExpression = () =>{
        props.setKpiInfo({...props.kpiInfo, cron:""})
        setOpened(true);
    }
    const clearSelectedAggregations = () =>{
        props.setKpiInfo({...props.kpiInfo, aggregationNames:[]})
        setOpenedCronUi(true);
    }
    

    return (
        <div className="step2__container wizard-content-card">
            <div>
                <Button onClick={isAggregation} color="teal" variant="outline" sx={themeProvider}>Choose Dependent
                    Aggregations</Button>
                {props.kpiInfo.aggregationNames && props.kpiInfo.aggregationNames.length!==0 && <FontAwesomeIcon icon={faCheck} style={{marginLeft:"1rem"}}/>}
            </div>
            <Divider sx={(t) => ({
                width: "80%",
            })} className={"solid"} my="xl" label="OR" labelPosition="center"/>
            <div>
                <Button onClick={isScheduler} color="teal" sx={themeProvider} variant="outline">Don't have dependents?
                    Schedule It</Button>
                {props.kpiInfo.cron && <FontAwesomeIcon icon={faCheck} style={{marginLeft:"1rem"}}/>}
            </div>
            {schedulerError && <Text color="red">{schedulerError}</Text>}
             <CronUIModal {...props} opened={openedCronUi} setOpened={setOpenedCronUi}/>
            <AggregationModal {...props} opened={opened} setOpened={setOpened}/>
            <ConfirmationPopUp 
                openConfirmModal={openConfirmModal} 
                setOpenConfirmModal={setOpenConfirmModal} 
                message="Do you want to clear cron expression?"
                successMethod = {clearCronExpression}
                rejectMethod = {()=>{setOpened(true);}}
            />
            <ConfirmationPopUp 
                openConfirmModal={openAggrConfirmModal} 
                setOpenConfirmModal={setOpenAggrConfirmModal} 
                message="Do you want to clear currently Scheduled Aggregations?"
                successMethod = {clearSelectedAggregations}
                rejectMethod = {()=>{setOpenedCronUi(true);}}
            />
        </div>);

}
